export default __webpack_public_path__ + "static/media/findYourCharity.85dd3308.webp";